// Brand colors from logo
const colors = {
    primaryGreen: '#5a8f32',
    primaryGreenDark: '#2C5032',
    primaryGreenLight: '#8fb069',
    darkGreen: '#2d5016',
    paleGreen: '#a4c77d',
    veryLightGreen: '#b8d191',
    action: "#ea580c",
    starYellow: '#fbbf24',
    lightGray: '#f3f4f6',
    mediumGray: '#9ca3af',
    darkGray: '#333a48',
    cookieBarGray: '#2B373B',
    errorRed: '#ef4444',
    blue50: '#e3f0fd',
    blue100: '#d7eafb',
    blue300: '#9bc9f4',
    blue700: '#1a73e8',
    blue900: '#155ab6',
    // Additional colors from landing page
    primary100: "#e7f3ee",
    text900: "#0b1020",
    text700: "#333a48",
    text600: "#6b7280",
    text500: "#5b6473",
    bgWeak: "#f6f7fb",
    card: "#ffffff",
    border: "#e6e8ee",
    zillaGreen: "#669664",
};

export default colors;
